import { createFetcher } from '../../Common';

import { APPLICANT_ENDPOINT, getBaseUrl } from '../../constants';

import { normalizeApplication, toApplicationPayload } from '../normalizers';

export class Applicant {
  static instance;

  static getInstance() {
    if (!this.instance) {
      this.instance = new Applicant(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = APPLICANT_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getApplicantById(reqId) {
    const url = `${this.base_url + this.endpoint}/${reqId}`;
    const response = await this.fetcher.getData(url);
    return normalizeApplication(response?.data);
  }

  async putApplicantById(reqParam) {
    const url = `${this.base_url + this.endpoint}/${reqParam.reqId}`;
    const response = await this.fetcher.putData(url, toApplicationPayload(reqParam.reqBody));
    return normalizeApplication(response?.data);
  }
}

export const createApplicant = () => Applicant.getInstance();
